(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    }).format(cents / 100);
  }

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function normalizeOption(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function variantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value != null;
    });
  }

  function optionNames(product) {
    if (!product || !Array.isArray(product.options)) return [];
    return product.options.map(function (option) {
      return typeof option === 'string' ? option : option.name;
    });
  }

  function sameOptions(left, right) {
    if (left.length !== right.length) return false;
    return left.every(function (value, index) {
      return normalizeOption(value) === normalizeOption(right[index]);
    });
  }

  function hasPhysicalStock(variant) {
    if (!variant) return false;
    if (!variant.inventory_management) return true;

    var quantity = Number(variant.inventory_quantity);
    if (Number.isFinite(quantity)) return quantity > 0;

    // Shopify's storefront variant JSON does not always include inventory_quantity.
    // The original products use "deny" at zero inventory, so availability is the
    // reliable fallback when a shopper changes variants on the product page.
    return Boolean(variant.available);
  }

  function PreorderPurchase(container) {
    this.container = container;
    this.form = container.closest('form');
    this.section = container.closest('[data-section-type="product"]');
    this.mode = container.dataset.mode || 'sold_out_preorder';
    this.message = container.dataset.message || 'ESTIMATED DELIVERY: 45–60 DAYS';
    this.offerHandle = container.dataset.offerProductHandle || '';
    this.originalOptionNames = parseJson(container.dataset.originalOptionNames || '[]', []);
    this.button = container.querySelector('[data-aspyr-preorder-submit]');
    this.title = container.querySelector('[data-aspyr-preorder-title]');
    this.error = container.querySelector('[data-aspyr-preorder-error]');
    this.standardButton = container.querySelector('.aspyr-preorder-standard__button');
    this.soldoutButton = container.querySelector('[data-aspyr-preorder-soldout]');
    this.offerProduct = null;
    this.offerVariants = [];

    var productJson = container.querySelector('[data-aspyr-preorder-offer-product]');
    if (productJson) {
      this.offerProduct = parseJson(productJson.textContent, null);
      this.offerVariants = this.offerProduct && Array.isArray(this.offerProduct.variants)
        ? this.offerProduct.variants
        : [];
    }

    if (!this.form || !this.section || !this.button || !this.title) return;

    this.currentVariant = {
      id: Number(this.button.dataset.currentVariantId || 0),
      title: this.button.dataset.currentVariantTitle || '',
      options: parseJson(this.button.dataset.currentVariantOptions || '[]', []),
      price: Number(this.button.dataset.currentVariantPrice || 0),
      compare_at_price: Number(this.button.dataset.currentVariantCompare || 0),
      available: this.button.dataset.currentVariantAvailable === 'true',
      inventory_management: this.button.dataset.currentVariantInventoryManagement || null,
      inventory_quantity: Number(this.button.dataset.currentVariantInventoryQuantity || 0)
    };

    this.button.addEventListener('click', this.addPreorder.bind(this));
    this.section.addEventListener('variantChange', function (event) {
      this.sync(event.detail && event.detail.variant);
    }.bind(this));

    this.sync(this.currentVariant);

    if (!this.offerProduct && this.offerHandle) {
      this.loadOfferProduct();
    }
  }

  PreorderPurchase.prototype.loadOfferProduct = function () {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';

    fetch(root + 'products/' + encodeURIComponent(this.offerHandle) + '.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Pre-order product is not available.');
        return response.json();
      })
      .then(function (product) {
        this.offerProduct = product;
        this.offerVariants = Array.isArray(product.variants) ? product.variants : [];
        this.button.hidden = false;
        this.sync(this.currentVariant);
      }.bind(this))
      .catch(function () {
        // Draft offers remain hidden until they are available to the Online Store.
        this.button.hidden = true;
      }.bind(this));
  };

  PreorderPurchase.prototype.findOfferVariant = function (variant) {
    if (!this.offerVariants.length || !variant) return null;

    var selectedValues = variantOptions(variant);
    var selectedByName = {};
    this.originalOptionNames.forEach(function (name, index) {
      selectedByName[normalizeOption(name)] = selectedValues[index];
    });

    var offerOptionNames = optionNames(this.offerProduct);
    var exact = this.offerVariants.find(function (offer) {
      var values = variantOptions(offer);
      if (!offerOptionNames.length || offerOptionNames.length !== values.length) return false;

      return offerOptionNames.every(function (name, index) {
        var selected = selectedByName[normalizeOption(name)];
        return selected != null && normalizeOption(selected) === normalizeOption(values[index]);
      });
    });

    if (exact) return exact;

    exact = this.offerVariants.find(function (offer) {
      return sameOptions(variantOptions(offer), selectedValues);
    });

    if (exact) return exact;

    var originalTitle = normalizeOption(variant.title);
    return this.offerVariants.find(function (offer) {
      return normalizeOption(offer.title) === originalTitle;
    }) || (this.offerVariants.length === 1 ? this.offerVariants[0] : null);
  };

  PreorderPurchase.prototype.renderPrice = function (variant, comparePrice) {
    if (!variant) return 'PRE-ORDER';
    var html = 'PRE-ORDER <span aria-hidden="true">&bull;</span> ';
    var comparison = Number(comparePrice || variant.compare_at_price || 0);
    if (comparison > Number(variant.price)) {
      html += '<s>' + formatMoney(comparison) + '</s> ';
    }
    return html + '<span>' + formatMoney(variant.price) + '</span>';
  };

  PreorderPurchase.prototype.syncStockButtons = function (variant) {
    var inStock = this.mode === 'dual' && hasPhysicalStock(variant) && variant.available;

    if (this.standardButton) {
      this.standardButton.hidden = !inStock;
      this.standardButton.disabled = !inStock;

      var standardText = this.standardButton.querySelector('[data-add-to-cart-text]');
      if (standardText && variant) {
        var standardHtml = 'ADD TO CART <span aria-hidden="true">&bull;</span> ';
        if (Number(variant.compare_at_price) > Number(variant.price)) {
          standardHtml += '<s>' + formatMoney(variant.compare_at_price) + '</s> ';
        }
        standardText.innerHTML = standardHtml + '<span>' + formatMoney(variant.price) + '</span>';
      }
    }

    if (this.soldoutButton) {
      this.soldoutButton.hidden = inStock;
    }
  };

  PreorderPurchase.prototype.sync = function (variant) {
    if (!variant) {
      this.button.disabled = true;
      return;
    }

    this.currentVariant = variant;
    this.syncStockButtons(variant);

    if (this.offerHandle && !this.offerProduct) {
      this.preorderVariant = null;
      this.button.hidden = true;
      this.button.disabled = true;
      return;
    }

    var target = this.offerVariants.length ? this.findOfferVariant(variant) : variant;
    this.preorderVariant = target;
    this.button.hidden = false;

    if (!target || !target.available) {
      this.title.textContent = 'PRE-ORDER UNAVAILABLE';
      this.button.disabled = true;
      return;
    }

    var comparison = Number(target.compare_at_price || 0);
    if (!(comparison > Number(target.price)) && Number(variant.price) > Number(target.price)) {
      comparison = Number(variant.price);
    }

    this.title.innerHTML = this.renderPrice(target, comparison);
    this.button.disabled = false;
  };

  PreorderPurchase.prototype.addPreorder = function () {
    if (!this.preorderVariant || this.button.disabled) return;

    var data = new FormData(this.form);
    data.set('id', this.preorderVariant.id);
    data.set('properties[Pre-Order]', this.message);
    data.set('properties[_Preorder]', 'true');
    data.set('properties[_Original product title]', this.container.dataset.productTitle || '');
    data.set('properties[_Original product URL]', this.container.dataset.productUrl || '');

    var bundlePayload = window.AspyrQuantityBundle && window.AspyrQuantityBundle.buildCartItems
      ? window.AspyrQuantityBundle.buildCartItems(this.form, this.preorderVariant, {
          'Pre-Order': this.message,
          '_Preorder': 'true',
          '_Original product title': this.container.dataset.productTitle || '',
          '_Original product URL': this.container.dataset.productUrl || ''
        })
      : null;
    if (bundlePayload && bundlePayload.error) return;

    this.button.disabled = true;
    this.button.classList.add('btn--loading');
    if (this.error) this.error.hidden = true;

    var requestOptions = {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    };
    if (bundlePayload) {
      requestOptions.headers['Content-Type'] = 'application/json';
      requestOptions.body = JSON.stringify({ items: bundlePayload.items });
    } else {
      requestOptions.body = data;
    }

    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', requestOptions)
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || payload.status === 422) throw payload;
          return payload;
        });
      })
      .then(function (product) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: product, addToCartBtn: this.button }
        }));
      }.bind(this))
      .catch(function (error) {
        if (this.error) {
          this.error.textContent = error.description || error.message || 'This preorder could not be added. Confirm that Continue selling when out of stock is enabled.';
          this.error.hidden = false;
        }
      }.bind(this))
      .finally(function () {
        this.button.classList.remove('btn--loading');
        this.button.disabled = !this.preorderVariant || !this.preorderVariant.available;
      }.bind(this));
  };

  function dedupePreorderCards() {
    document.querySelectorAll('[data-aspyr-preorder-card]').forEach(function (card) {
      var parent = card.parentElement;
      var productId = card.dataset.productId;
      if (!parent || !productId) return;

      var matches = parent.querySelectorAll('[data-aspyr-preorder-card][data-product-id="' + productId + '"]');
      Array.prototype.slice.call(matches, 1).forEach(function (duplicate) {
        duplicate.remove();
      });
    });
  }

  function RestockModal(modal) {
    this.modal = modal;
    this.trigger = document.querySelector('[data-aspyr-restock-open="' + modal.id + '"]');
    this.closeButtons = modal.querySelectorAll('[data-aspyr-restock-close]');
    this.form = modal.querySelector('.aspyr-restock-form');
    this.previouslyFocused = null;

    if (!this.trigger) return;

    this.trigger.addEventListener('click', this.open.bind(this));
    this.closeButtons.forEach(function (button) {
      button.addEventListener('click', this.close.bind(this));
    }.bind(this));
    this.modal.addEventListener('keydown', this.onKeydown.bind(this));
    if (this.form) this.form.addEventListener('submit', this.trackRequest.bind(this));

    if (this.modal.querySelector('[data-aspyr-restock-feedback]')) {
      this.open();
    }
  }

  RestockModal.prototype.focusableElements = function () {
    return Array.prototype.filter.call(
      this.modal.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href]'),
      function (element) { return element.offsetParent !== null; }
    );
  };

  RestockModal.prototype.open = function () {
    this.previouslyFocused = document.activeElement;
    this.modal.hidden = false;
    document.documentElement.classList.add('aspyr-restock-open');
    document.body.classList.add('aspyr-restock-open');

    var firstField = this.modal.querySelector('.aspyr-restock-form input:not([type="hidden"]), .aspyr-restock-modal__close');
    if (firstField) window.setTimeout(function () { firstField.focus(); }, 30);
  };

  RestockModal.prototype.trackRequest = function () {
    if (!this.form) return;
    var email = this.form.querySelector('input[name="contact[email]"]');
    var phone = this.form.querySelector('input[name="contact[phone]"]');
    if (!email || !phone) return;

    window._learnq = window._learnq || [];
    window._learnq.push(['identify', {
      '$email': email.value.trim(),
      '$phone_number': phone.value.trim(),
      'Restock Product': this.modal.dataset.productTitle || '',
      'Restock Product Handle': this.modal.dataset.productHandle || '',
      'Restock SMS Consent': true
    }]);
    window._learnq.push(['track', 'ASPYR Restock Alert Requested', {
      'Product Name': this.modal.dataset.productTitle || '',
      'Product Handle': this.modal.dataset.productHandle || '',
      'Product URL': this.modal.dataset.productUrl || '',
      'Email and SMS Consent': true
    }]);
  };

  RestockModal.prototype.close = function () {
    this.modal.hidden = true;
    document.documentElement.classList.remove('aspyr-restock-open');
    document.body.classList.remove('aspyr-restock-open');
    if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
      this.previouslyFocused.focus();
    }
  };

  RestockModal.prototype.onKeydown = function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = this.focusableElements();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  function init() {
    document.querySelectorAll('[data-aspyr-preorder-purchase]').forEach(function (container) {
      if (container.dataset.aspyrPreorderReady === 'true') return;
      container.dataset.aspyrPreorderReady = 'true';
      new PreorderPurchase(container);
    });
    document.querySelectorAll('[data-aspyr-restock-modal]').forEach(function (modal) {
      if (modal.dataset.aspyrRestockReady === 'true') return;
      modal.dataset.aspyrRestockReady = 'true';
      new RestockModal(modal);
    });
    dedupePreorderCards();
    arrangeProductSizing();
  }

  function arrangeProductSizing() {
    var moved = false;
    document.querySelectorAll('.aspyr-fit').forEach(function (fit) {
      var section = fit.closest('[data-section-type="product"]');
      if (!section) return;

      var sizingBlock = fit.parentNode;
      var variants = sizingBlock.querySelectorAll('.variant-wrapper');
      var firstVariant = variants[0];
      var lastVariant = variants[variants.length - 1];
      if (!firstVariant || !lastVariant) return;
      var sizeInput = sizingBlock.querySelector('.variant-input-wrap[data-handle="size"]');
      var sizeVariant = sizeInput ? sizeInput.closest('.variant-wrapper') : firstVariant;

      var appBlocks = section.querySelectorAll('.shopify-app-block');
      var kiwiBlock = Array.prototype.find.call(appBlocks, function (block) {
        return /size\s*chart/i.test(block.textContent || '') ||
          block.querySelector('[class*="kiwi" i], [id*="kiwi" i]');
      });

      if (window.matchMedia('(max-width: 768px)').matches) {
        if (fit.nextElementSibling !== sizeVariant) {
          sizingBlock.insertBefore(fit, sizeVariant);
          moved = true;
        }
        if (kiwiBlock && kiwiBlock.nextElementSibling !== fit) {
          sizingBlock.insertBefore(kiwiBlock, fit);
          moved = true;
        }
      } else {
        if (lastVariant.nextElementSibling !== kiwiBlock && lastVariant.nextElementSibling !== fit) {
          lastVariant.insertAdjacentElement('afterend', fit);
          moved = true;
        }
        if (kiwiBlock && (lastVariant.nextElementSibling !== kiwiBlock || kiwiBlock.nextElementSibling !== fit)) {
          sizingBlock.insertBefore(kiwiBlock, fit);
          moved = true;
        }
      }
    });
    return moved;
  }

  var kiwiPositionObserver = new MutationObserver(function () {
    arrangeProductSizing();
  });

  kiwiPositionObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', arrangeProductSizing);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
}());
